<template>
  <div
    class="heading">
    <span>
      <slot />
    </span>
  </div>
</template>
<style lang="scss">
.heading {
  display: inline;
  color: var(--white);
  font-size: var(--font-size-xxxxl);
  line-height: 1.5em;
  font-weight: var(--font-weight-heading);
  font-family: var(--font-heading);
  text-transform: uppercase;
  width: 100%;
  vertical-align: baseline;

  span {
    background: var(--black);
    padding: calc(var(--spacing) * 0.5) calc(var(--spacing) * 1.5);
    line-height: 1.4em;
    box-decoration-break: clone;
  }

  @media (max-width: #{$breakpoint-tablet}) {
    font-size: var(--font-size-xxxl);
    line-height: 1.2em;

    span {
      padding: calc(var(--spacing) * 0.5) var(--spacing);
    }
  }

  @media (max-width: #{$breakpoint-mobile}) {
    font-size: var(--font-size-xxl);
    line-height: 1.4em;
  }

  &--transparent-black {
    span {
      background-color: transparent;
      color: var(--black);
    }
  }

  &--white-black {
    span {
      background-color: var(--white);
      color: var(--black);
    }
  }

  &--pink-white {
    padding: 0 calc(var(--spacing) * 0.5);
    background: rgb(228 34 133);
    color: var(--white);

    span {
      background-color: transparent;
    }

  }

  &--gold-white {
    span {
      background-color: var(--gold);
      color: var(--white);
    }
  }

  &--small {
    font-size: var(--font-size-m);
    line-height: 1.7;

    span {
      padding: calc(var(--spacing) * 0.5) var(--spacing);

    }

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size);
    }

    @media (max-width: #{$breakpoint-tiny}) {
      font-size: var(--font-size-s);
    }
  }

  &--tiny {
    font-size: var(--font-size);

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size-xs);

      span {
        padding: calc(var(--spacing) * 0.5);
      }
    }

    span {
      line-height: 2em;
    }
  }

  &--miniature {
    font-size: var(--font-size-l);

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size);
    }
  }

  &--small-tiny {
    font-size: var(--font-size-l);

    span {
      padding: calc(var(--spacing) * 0.5) var(--spacing);
      line-height: 1.7em;
    }

    @media (max-width: #{$breakpoint-tablet}) {
      font-size: var(--font-size-m);
    }

    @media (max-width: #{$breakpoint-small-desktop}) {
      font-size: var(--font-size-s);
    }

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size-s);

      span {
        padding: calc(var(--spacing) * 0.5);
      }
    }

    @media (max-width: #{$breakpoint-tiny}) {
      font-size: var(--font-size-s);
    }
  }

  &--medium {
    font-size: var(--font-size-xl);
    line-height: 1.7;

    @media (max-width: #{$breakpoint-tablet}) {
      font-size: var(--font-size-m);
    }

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size-m);
    }

    span {
      padding: calc(var(--spacing) * 0.5) var(--spacing);
    }
  }

  &--big {
    font-size: var(--font-size-xxl);

    span {
      padding: calc(var(--spacing) * 0.5) var(--spacing);
    }

    @media (max-width: #{$breakpoint-small-desktop}) {
      font-size: var(--font-size-xl);
    }

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size-l);
    }

    @media (max-width: #{$breakpoint-tiny}) {
      font-size: var(--font-size-m);
    }
  }

  &--big-small-padding {
    font-size: clamp(var(--font-size-l), 2.5vw, var(--font-size-xxxl));
    line-height: normal;
    padding: 0 calc(var(--spacing) * 0.5);

    span {
      line-height: normal;
      padding: 0;
    }

    @media (max-width: #{$breakpoint-tablet}) {
      font-size: var(--font-size-xxl);
    }

    @media (max-width: #{$breakpoint-mobile}) {
      font-size: var(--font-size-l);
    }

    @media (max-width: #{$breakpoint-tiny}) {
      font-size: var(--font-size-m);
    }
  }

  &--no-padding-left {
    span {
      padding-left: 0;
    }
  }
}
</style>
